import BigNumber from 'bignumber.js';
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import TradingBox from '../../../../molecules/TradingBox';
import ControlItem from '../../common/ControlItem';
import ParamField from '../../common/ParamField';
import NonEditableParamField from '../../common/NonEditableParamField';
import CreateButton from '../../common/CreateButton';
import latest from '../../../../assets/images/latest.svg';
import refresh from '../../../../assets/images/refresh.svg';
import big_arrow from '../../../../assets/images/arrow_down.svg';
import { SwapActions } from '../../reducers/swapReducer';
import { EOverlays, ETabs } from '../../reducers/tradingReducer';
import { getPercentFromBalance } from '../../helpers/balanceFormatters';
import { validateSettingsValue } from '../../helpers/settingsFormatters';
import { NativeCoin } from '../../helpers/nativeCoins';
import { formatTokenName } from '../../../../helpers/formatters';
import useElrondSwap from './useSwap/useElrondSwap';
import { ISwapProps } from '.';

const ElrondSwap = (props: ISwapProps) => {
  const { base, quote, account, slippage, setTab, onFlip, setSlippage } = props;

  const {
    estimateIndex,
    gasFees,
    priceImpact,
    tokenRoute,
    network,
    isSameChain,
    baseBalance,
    quoteBalance,
    price,
    minReceived,
    estimationBase,
    estimationQuote,
    loading,
    dispatch,
    onBaseUpdate,
    onQuoteUpdate,
    onSwap,
  } = useElrondSwap(props);

  const onImageClick = () => {
    if (!(tokenRoute == null)) {
      dispatch({
        payload: estimateIndex + 1,
        type: SwapActions.SetEstimateIndex,
      });
    }
  };

  const nativeCoin = NativeCoin(network?.toDecimal() || 1, new BigNumber(0));

  const createCondition =
    base.amount.isEqualTo(0) ||
    tokenRoute == null ||
    loading ||
    base.amount.isGreaterThan(baseBalance);

  return (
    <div className='container'>
      <TradingBox
        network={network as any}
        estimation={estimationBase}
        disabled={!isSameChain}
        title='Send'
        balance={baseBalance}
        coinAddress={base.address}
        coinTitle={base.name}
        value={base.amount}
        onChange={onBaseUpdate}
        setTab={() => props.setOverlay(EOverlays.BaseCurrencyMenu)}
        isCoinChangable
      />
      <div className='row percents'>
        <Text
          size={12}
          className={`percents__item ${
            !base.amount.eq(0) &&
            base.amount.eq(getPercentFromBalance(baseBalance, 0.2))
              ? 'percents__item--active'
              : ''
          }`}
          onClick={() => onBaseUpdate(getPercentFromBalance(baseBalance, 0.2))}
        >
          20%
        </Text>
        <Text
          size={12}
          className={`percents__item ${
            !base.amount.eq(0) &&
            base.amount.eq(getPercentFromBalance(baseBalance, 0.35))
              ? 'percents__item--active'
              : ''
          }`}
          onClick={() => onBaseUpdate(getPercentFromBalance(baseBalance, 0.35))}
        >
          35%
        </Text>
        <div className='big_arrow'>
          <Image src={big_arrow} size='s' onClick={onFlip} />
        </div>
        <Text
          size={12}
          className={`percents__item ${
            !base.amount.eq(0) &&
            base.amount.eq(getPercentFromBalance(baseBalance, 0.5))
              ? 'percents__item--active'
              : ''
          }`}
          onClick={() => onBaseUpdate(getPercentFromBalance(baseBalance, 0.5))}
        >
          50%
        </Text>
        <Text
          size={12}
          className={`percents__item ${
            !base.amount.eq(0) &&
            base.amount.eq(getPercentFromBalance(baseBalance, 0.65))
              ? 'percents__item--active'
              : ''
          }`}
          onClick={() => onBaseUpdate(getPercentFromBalance(baseBalance, 0.65))}
        >
          65%
        </Text>
      </div>
      <TradingBox
        network={network as any}
        estimation={estimationQuote}
        disabled={!isSameChain}
        title='Receive'
        balance={quoteBalance}
        coinAddress={quote.address}
        coinTitle={quote.name}
        value={quote.amount}
        onChange={onQuoteUpdate}
        setTab={() => props.setOverlay(EOverlays.QuoteCurrencyMenu)}
        isCoinChangable
      />
      <div className='tab_selector'>
        <div className='tab tab--active' onClick={() => setTab(ETabs.Swap)}>
          <Text size={14}>Market</Text>
        </div>
        {/* <div className='tab' onClick={() => setTab(ETabs.Limit)}>
          <Text size={12}>Limit</Text>
        </div> */}
      </div>
      <div className='params_panel'>
        <NonEditableParamField
          title='Price'
          text={`${price.toFixed(4)} ${formatTokenName(
            base.name
          )} per ${formatTokenName(quote.name)}`}
        />
        <ParamField
          title='Slippage'
          value={slippage.toString()}
          validateValue={(value) => validateSettingsValue(value, 0.5, 50)}
          onSave={(value) => setSlippage(value)}
          ending='%'
        />
      </div>
      <div className='stats_panel'>
        <div className='btn_margin'>
          <CreateButton
            createCondition={createCondition}
            onCreate={onSwap}
            label='Swap'
            chainId={network?.toDecimal()}
            isCorrectChain={isSameChain}
          />
        </div>
        <div className='stats_panel__stat'>
          <Text size={12} className='stats_panel__stat__title'>
            Minimum received
          </Text>
          <Text size={12} className='stats_panel__stat__value'>
            {minReceived} {quote.name}
          </Text>
        </div>
        <div className='stats_panel__stat'>
          <Text size={12} className='stats_panel__stat__title'>
            Price Impact
          </Text>
          <Text size={12} className='stats_panel__stat__value'>
            {priceImpact.toFixed(4)}%
          </Text>
        </div>
        <div className='stats_panel__stat'>
          <Text size={12} className='stats_panel__stat__title'>
            Total Fee
          </Text>
          <Text size={12} className='stats_panel__stat__value'>
            {gasFees}&nbsp;{nativeCoin.name}
          </Text>
        </div>
      </div>
      <div className='trading__footer'>
        {/* <div className='trading__footer__info_box'>
          <div className='trading__footer__info_box__item'>
            <Text size={12}>3.1200ETH</Text>
          </div>
          <div className='trading__footer__info_box__item'>
            <Text size={12}>$1360.00</Text>
            <div className='trading__footer__info_box__item__counter'>
              <Text size={10}>3</Text>
            </div>
          </div>
        </div> */}
        <div className='row'>
          <ControlItem
            disable={!account}
            imageUrl={latest}
            click={() => setTab(ETabs.RecentTrades)}
          />
          <ControlItem
            disable={!tokenRoute || !account}
            imageUrl={refresh}
            click={onImageClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ElrondSwap;
